import { ApiErrorCodeEnum } from '../enums/api-error-code.enum';

/**
 * Base Api response
 */
export class BaseApiResponse {
	/**
	 * The error code of the response.
	 */
	errorCode!: ApiErrorCodeEnum;
	/**
	 * The error message of the response. Defaults to null.
	 */
	message?: string;
}
